import { useEffect } from "react";
import EnvelopeBlock from "../../components/envelope-block/envelope-block";
import HeroBlock from "../../components/hero-block/hero-block";
import "./main-page.scss";
import { gsap } from "gsap/all";

const MainPage = () => {
  const animationPin = () => {
    gsap.set(".hero-auth", {
      opacity: 0,
      y: 50,
      pointerEvents: "none",
    });
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#root",
        start: "top top",
        end: "+=500px",
        pin: true,
        scrub: true,
        anticipatePin: 1,
      },
    });

    tl.to([".hero__text", ".hero__title"], {
      opacity: 0,
      filter: "blur(5px)",
      y: -50,
      pointerEvents: "none",
    });
    tl.to(".hero-auth", {
      opacity: 1,
      y: 0,
      pointerEvents: "all",
    });
  };
  useEffect(() => {
    setTimeout(() => {
      animationPin();
    }, 0);
  }, []);
  return (
    <main className="index">
      <HeroBlock />
      <EnvelopeBlock />
    </main>
  );
};

export default MainPage;
